import http from '@/plugins/http';
import groupJobUpdate from '../../transformers/job/groupJobUpdate';

export default (data) => new Promise((res, rej) => {
  const transformedData = groupJobUpdate.send(data);
  http.patch('/v3/jobs/edit', transformedData)
    .then((response) => {
      res(response.data);
    })
    .catch((error) => {
      rej(error);
    });
});
